import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { cilCheckCircle, cilXCircle } from "@coreui/icons";
import { finalize } from "rxjs/operators";

@Component({
    selector: "app-confirm-reservation",
    templateUrl: "./confirm-reservation.component.html",
    styleUrls: ["./confirm-reservation.component.scss"],
    standalone: false
})
export class ConfirmReservationComponent implements OnInit {
  @Input() ticketContext?: {companyName:string;reservationId:string;language?:string};
  icons = { cilCheckCircle, cilXCircle };
  errorMessage: string | null = null;

  reservationId!: string;
  companyName!: string;
  success: boolean | null = null;
  isLoading = false;

  showConfirmModal = false;
  private confirmed = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private translate: TranslateService
  ) {
    const supportedLanguages = ['en', 'tr', 'es', 'el', 'de'];
    this.translate.addLangs(supportedLanguages);
    this.translate.setDefaultLang('en');

    const browserLang = navigator.language.split('-')[0]; // e.g. "tr-TR" → "tr"
    if (supportedLanguages.includes(browserLang)) {
      this.translate.use(browserLang);
    } else {
      this.translate.use('en'); // fallback
    }
  }

  ngOnInit(): void {
    if (this.ticketContext) {
      if(this.ticketContext.language)this.translate.use(this.ticketContext.language);
      this.companyName=this.ticketContext.companyName;
      this.reservationId=this.ticketContext.reservationId;

      return;
    }

    this.route.paramMap.subscribe((params) => {
      const company = params.get("companyName");
      const id = params.get("reservationId");

      if (company && id) {
        this.companyName = decodeURIComponent(company);
        this.reservationId = id;

        console.log("[DEBUG] companyName:", this.companyName);
        console.log("[DEBUG] reservationId:", this.reservationId);
      } else {
        console.warn("[WARN] Missing parameters!");
        this.success = false;
      }
    });
  }

  confirmReservation(): void {
    if (this.isLoading || this.confirmed) return;

    this.isLoading = true;

    const url = `${environment.baseUrl}/users/get-id-by-company-name`;

    this.http
      .get<any>(url, {
        params: { company_name: this.companyName },
      })
      .subscribe({
        next: (res) => {
          const userId = res.user_id;
          console.log("[DEBUG] Fetched user ID:", userId);

          if (!userId) {
            console.error("[ERROR] User ID not found!");
            this.success = false;
            this.isLoading = false;
            return;
          }

          // ✅ Backend route: POST /reservations/:userId/:reservationId
          const confirmUrl = `${environment.baseUrl}/confirm/reservations/${userId}/${this.reservationId}`;
          console.log("[DEBUG] Confirm URL:", confirmUrl);

          this.http
            .post(confirmUrl, {})
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
              next: () => {
                console.log("[INFO] Reservation successfully confirmed");
                this.success = true;
                this.confirmed = true;
              },
              error: (err) => {
                console.error("[ERROR] Confirm failed:", err);
                this.success = false;

                // ✅ store server message if available
                if (err.error && err.error.error) {
                  this.errorMessage = err.error.error;
                } else {
                  this.errorMessage = this.translate.instant(
                    "CONFIRM_PAGE.ERROR_MESSAGE"
                  );
                }
              },
            });
        },
        error: (err) => {
          console.error("[ERROR] User ID fetch failed:", err);
          this.success = false;
          this.isLoading = false;
        },
      });
  }

  onConfirmClick(): void {
    this.showConfirmModal = true;
  }

  confirmReservationDecision(decision: boolean): void {
    this.showConfirmModal = false;
    if (decision) {
      this.confirmReservation();
    }
  }
}
